<template>
    <span v-if="mostrarBtn">
        <b-button variant="danger" @click.stop="abrirModal()">
            <span> <i class="fa fa-thumbs-o-down"></i> Não Aceitar </span>
        </b-button>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Solicitação de Consultoria - Não Aceite
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmar()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-thumbs-o-down"></i> Não Aceitar
                    </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: ''
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.justificativa = ''
        },

        confirmar() {
            this.$swal({
                title: `Solicitação de Consultoria`,
                html: 'Confirma o NÃO ACEITE da solicitação de consultoria?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.naoAceitar()
                }
            })
        },

        naoAceitar() {
            this.$store.dispatch('addRequest')
            let naoAceiteDto = {
                consultoriaId: this.$route.params.consultoriaId,
                justificativa: this.justificativa
            }
            this.services.naoAceitar(naoAceiteDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Solicitação não aceita com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterConsultoriaAtualizada')
                    } else {
                        this.$toast.error(
                            'Erro ao processar a solicitação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-01') &&
                this.consultoria.status ===
                    consultoriaStatus.AGUARDANDO_ACEITACAO_CREDENCIADA
            )
        }
    },

    validations: {
        justificativa: {
            required
        }
    }
}
</script>
